/** Único utilizador autorizado a ver consultas SQL completas na UI. */
export const SQL_VIEWER_ALLOWED_EMAIL = 'admin@cobrancas.com';

export function canViewSql(email: string | null | undefined): boolean {
  return (email?.trim().toLowerCase() ?? '') === SQL_VIEWER_ALLOWED_EMAIL.toLowerCase();
}
